module.exports = __webpack_public_path__ + "static/media/weatherboy-image.fe21a3d5.png";